<template>
  <div class="fixed top-0 left-0 z-20 w-full bg-primary-purple">
    <div class="mx-auto border-b-2 border-color lg:px-12 xl:px-20 3xl:max-w-[1720px] 3xl:px-0">
      <TopNav ref="topNav" />
      <CategoriesNav @active="closeAllCategoriesDropdown" />
    </div>
    <PromoBlock v-if="showPromo" />
    <DunningSnackbar />
  </div>
</template>

<script>
import DunningSnackbar from '@/components/Dunning/dunning-snackbar.vue';
import PromoBlock from './promo-block.vue';
import TopNav from './top-nav.vue';
import CategoriesNav from './categories-nav.vue';

export default {
  components: {
    PromoBlock,
    DunningSnackbar,
    TopNav,
    CategoriesNav,
  },

  inject: ['hasPromo', 'hasHolidayPromo', 'hasReferralCode', 'hasExtraMonthsBenefit', 'hasReactivationPromo'],

  computed: {
    showPromo() {
      if (this.hasReactivationPromo()) {
        return true;
      }
      const { path } = this.$route;
      if (this.hasReferralCode() || this.hasExtraMonthsBenefit()) {
        return path === '/pricing/';
      }

      if (this.hasPromo && this.hasHolidayPromo) {
        return path === '/';
      }
      return (
        this.hasPromo && (path.startsWith('/pricing') || path.startsWith('/account/subscription'))
      );
    },
  },

  methods: {
    closeAllCategoriesDropdown() {
      this.$refs.topNav.$refs.searchBlock.$refs.searchCategoriesDropdown.active = false;
    },
  },
};
</script>

<style scoped>
.border-color {
  border-bottom-color: #1C1E3D;
}
@screen 3xl {
  .\33xl\:max-w-\[1720px\] {
    max-width: 1720px;
  }
}
</style>
